import { PluginContainerData } from "./common.js";
import { GIFData_GIFType } from "./plugin_gif.enums.js";
function gIFData_GIFTypeFromJSON(object) {
  switch (object) {
    case 0:
    case "NORMAL":
      return GIFData_GIFType.NORMAL;
    case 1:
    case "STICKER":
      return GIFData_GIFType.STICKER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GIFData_GIFType.UNRECOGNIZED;
  }
}
function gIFData_GIFTypeToJSON(object) {
  switch (object) {
    case GIFData_GIFType.NORMAL:
      return "NORMAL";
    case GIFData_GIFType.STICKER:
      return "STICKER";
    default:
      return "UNKNOWN";
  }
}
const baseGIFData = { height: 0, width: 0, gifType: GIFData_GIFType.NORMAL };
const GIFData = {
  fromJSON(object) {
    const message = { ...baseGIFData };
    message.containerData = object.containerData !== void 0 && object.containerData !== null ? PluginContainerData.fromJSON(object.containerData) : void 0;
    message.original = object.original !== void 0 && object.original !== null ? GIF.fromJSON(object.original) : void 0;
    message.downsized = object.downsized !== void 0 && object.downsized !== null ? GIF.fromJSON(object.downsized) : void 0;
    message.height = object.height !== void 0 && object.height !== null ? Number(object.height) : 0;
    message.width = object.width !== void 0 && object.width !== null ? Number(object.width) : 0;
    message.gifType = object.gifType !== void 0 && object.gifType !== null ? gIFData_GIFTypeFromJSON(object.gifType) : GIFData_GIFType.NORMAL;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.containerData !== void 0 && (obj.containerData = message.containerData ? PluginContainerData.toJSON(message.containerData) : void 0);
    message.original !== void 0 && (obj.original = message.original ? GIF.toJSON(message.original) : void 0);
    message.downsized !== void 0 && (obj.downsized = message.downsized ? GIF.toJSON(message.downsized) : void 0);
    message.height !== void 0 && (obj.height = Math.round(message.height));
    message.width !== void 0 && (obj.width = Math.round(message.width));
    message.gifType !== void 0 && (obj.gifType = gIFData_GIFTypeToJSON(message.gifType));
    return obj;
  }
};
const baseGIF = {};
const GIF = {
  fromJSON(object) {
    const message = { ...baseGIF };
    message.gif = object.gif !== void 0 && object.gif !== null ? String(object.gif) : void 0;
    message.mp4 = object.mp4 !== void 0 && object.mp4 !== null ? String(object.mp4) : void 0;
    message.still = object.still !== void 0 && object.still !== null ? String(object.still) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.gif !== void 0 && (obj.gif = message.gif);
    message.mp4 !== void 0 && (obj.mp4 = message.mp4);
    message.still !== void 0 && (obj.still = message.still);
    return obj;
  }
};
export {
  GIF,
  GIFData,
  gIFData_GIFTypeFromJSON,
  gIFData_GIFTypeToJSON
};
//# sourceMappingURL=plugin_gif.js.map
